import { all, put, takeLatest, call, delay } from 'redux-saga/effects';
import { OrganisationUserActionTypes } from 'types';
import {
  fetchOrganisationUsersStart,
  fetchOrganisationUsersSuccess,
  fetchOrganisationUsersFailure,
  addOrganisationUserSuccess,
  addOrganisationUserFailure,
  deleteUserSuccess,
  setAdminUserModelOpenStart
} from './action';

import { addAlert } from 'redux/alerts/actions';

import Services from 'services';

export function* doFetchOrganisationUsers(request: any) {
  try {
    const response = yield call(
      Services.organisationUser.fetchUsersByOrganisationId,
      request?.payload?.organisationId // organisationId
    );
    if (response.error) {
      throw new Error(response.error.message);
    }
    yield put(fetchOrganisationUsersSuccess(response));
  } catch (error) {
    yield put(fetchOrganisationUsersFailure(error.message));
  }
}
export function* doAddOrganisationUsers(request: any) {
  try {
    const response = yield call(
      Services.organisationUser.addOrganisationUser,
      request?.payload // AddUserRequest
    );

    if (response.error) {
      throw new Error(response.error.message);
    }

    yield put(addOrganisationUserSuccess());
    yield put(fetchOrganisationUsersStart(request.payload.orgId));
    yield delay(1000);
    yield put(setAdminUserModelOpenStart(false));
  } catch (error) {
    yield put(addOrganisationUserFailure(error.message));
  }
}
export function* doDeleteUsers(request: any) {
  try {
    yield call(
      Services.organisationUser.deleteUser,
      request?.payload // DeleteUserRequest
    );
    yield put(deleteUserSuccess());
    yield put(fetchOrganisationUsersStart(request.payload.orgId));
  } catch (error) {
    yield put(
      addAlert(
        'DELETE_USER_GROUP',
        'error',
        error.response?.data?.error?.message,
        '',
        { withClose: false }
      )
    );
  }
}
export function* doSetAdminUserModelOpen() {}

function* onFetchOrganisationUsers() {
  yield takeLatest(
    OrganisationUserActionTypes.FETCH_USERS_BY_ORG_ID_START,
    doFetchOrganisationUsers
  );
}

function* onAddOrganisationUsers() {
  yield takeLatest(
    OrganisationUserActionTypes.ADD_USERS_TO_ORG_START,
    doAddOrganisationUsers
  );
}

function* onSetAdminUserModelOpen() {
  yield takeLatest(
    OrganisationUserActionTypes.OPEN_ADD_ADMINISTRATOR_MODAL_START,
    doSetAdminUserModelOpen
  );
}
function* onDeleteUser() {
  yield takeLatest(
    OrganisationUserActionTypes.DELETE_USERS_TO_ORG_START,
    doDeleteUsers
  );
}
export function* doRemoveError() {}

function* onRemoveError() {
  yield takeLatest(OrganisationUserActionTypes.REMOVE_ERROR, doRemoveError);
}
function* OrganisationUserSagas() {
  yield all([
    call(onFetchOrganisationUsers),
    call(onAddOrganisationUsers),
    call(onSetAdminUserModelOpen),
    call(onDeleteUser),
    call(onRemoveError)
  ]);
}
export default OrganisationUserSagas;
